import Vue from 'vue';
import Router from 'vue-router';
import MeetRoom from '@/views/MeetRoom.vue';
import CreateRoom from '@/views/CreateRoom.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/meet/:roomId',
      component: CreateRoom,
      meta: { showHeader: true },
    },
    {
      path: '/meet/:roomId',
      component: MeetRoom,
      meta: { showHeader: false },
      props: (route) => ({
        roomId: route.params.roomId,
        participantName: route.query.name,
      }),
    },
  ],
});
